/** PRAT-165 — lembranças do aparelho (localStorage, sempre com try/catch). */

/** PRAT-43: "Agora não" em qualquer convite espera 7 dias (no aparelho, em todas as lojas). */
const DISMISS_DAYS = 7;
const SNOOZE_KEY = 'pratigo:push-agora-nao';
/**
 * PRAT-90: até 01/11/2026 a CSP bloqueava a config do OneSignal e todo "Ativar"
 * falhava. "Agora não" dado antes disso não vale: todo mundo é convidado de novo.
 */
const SNOOZE_VALID_FROM = Date.UTC(2026, 10, 1, 0, 0);
const snoozedAt = () => {
  const at = Number(read(SNOOZE_KEY) || 0);
  return at >= SNOOZE_VALID_FROM ? at : 0;
};
const subscribedKey = (slug: string) => `pratigo:push-inscrito:${slug}`;
const claimedKey = (slug: string, userId: string) =>
  `pratigo:tela-inicial-brinde:${slug}:${userId}`;

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* modo privado: só não lembra */
  }
}

/** O cliente disse "Agora não" há menos de 7 dias: só a faixa discreta do pedido aparece. */
export function isPushSnoozed(now = Date.now()): boolean {
  const at = snoozedAt();
  return at > 0 && now - at < DISMISS_DAYS * 24 * 60 * 60 * 1000;
}

/** Já disse "Agora não" alguma vez (mesmo há mais de 7 dias). */
export function everSnoozedPush(): boolean {
  return snoozedAt() > 0;
}

export function snoozePush(now = Date.now()): void {
  write(SNOOZE_KEY, String(now));
}

export function isSubscribedToStore(slug: string): boolean {
  return read(subscribedKey(slug)) === '1';
}

export function markSubscribedToStore(slug: string): void {
  write(subscribedKey(slug), '1');
}

export function wasHomeScreenRewardClaimed(slug: string, userId: string): boolean {
  return read(claimedKey(slug, userId)) === '1';
}

export function markHomeScreenRewardClaimed(slug: string, userId: string): void {
  write(claimedKey(slug, userId), '1');
}

const DEVICE_KEY = 'pratigo:push-aparelho';

/** PRAT-201 — id aleatório do aparelho, para a taxa de aceite contar aparelhos. */
export function deviceId(): string {
  let id = read(DEVICE_KEY);
  if (!id) {
    id = `ap-${Math.random().toString(36).slice(2, 12)}`;
    write(DEVICE_KEY, id);
  }
  return id;
}

const visitKey = (slug: string) => `pratigo:loja-visita:${slug}`;
const RETURN_GAP_MS = 30 * 60 * 1000;

/**
 * PRAT-43 — o convite de ofertas é para quem VOLTA à loja, nunca na 1ª visita.
 * Volta = já esteve na loja há mais de 30 min. A resposta fica fixa na aba
 * (sessionStorage), para não sumir no meio da visita.
 */
export function isReturnVisit(slug: string, now = Date.now()): boolean {
  if (!slug) return false;
  const sessionKey = `pratigo:loja-volta:${slug}`;
  try {
    const cached = sessionStorage.getItem(sessionKey);
    if (cached !== null) return cached === '1';
  } catch {
    /* sem sessionStorage: calcula toda vez */
  }
  const prev = Number(read(visitKey(slug)) || 0);
  const back = prev > 0 && now - prev > RETURN_GAP_MS;
  write(visitKey(slug), String(now));
  try {
    sessionStorage.setItem(sessionKey, back ? '1' : '0');
  } catch {
    /* idem */
  }
  return back;
}

/** PRAT-201 — true só na 1ª vez que o convite aparece nesta aba (conta "viu" uma vez). */
export function firstPromptView(key: string): boolean {
  const k = `pratigo:push-convite-visto:${key}`;
  try {
    if (sessionStorage.getItem(k)) return false;
    sessionStorage.setItem(k, '1');
  } catch {
    /* sem sessionStorage: conta toda vez; a taxa usa aparelhos distintos */
  }
  return true;
}
